import Modal from './Modal'
import ModalCarousel from './ModalCarousel'
import ModalForestFirstAccess from './modal-forest-first-access'
import ModalPositivoFirstAccess from './ModalPositivoFirstAccess'
import ModalPremiumLock from './ModalPremiumLock'
import ModalProductNews from './ModalProductNews'
import ModalNotYourSchool from './ModalNotYourSchool'
import ModalRequestErrorHelper from './ModalRequestErrorHelper'
import ModalSubscriptionPaid from './ModalSubscriptionPaid'
import type { ModalProps } from './Modal.types'

import ModalExplanation from './modal-explanation'
import ModalIndication from './modal-indication'

export default Modal

export {
  ModalProps,
  Modal,
  ModalCarousel,
  ModalProductNews,
  ModalForestFirstAccess,
  ModalPositivoFirstAccess,
  ModalPremiumLock,
  ModalNotYourSchool,
  ModalRequestErrorHelper,
  ModalSubscriptionPaid,
  ModalExplanation,
  ModalIndication
}
